import PropTypes from "prop-types";
import SwiperCore, { Navigation, Pagination, A11y } from "swiper";
import { SwiperSlide, Swiper } from "swiper/react";

import { withALErrorBoundary } from "../../helpers/ErrorBoundary/ALErrorBoundary";
import { useProductData2 } from "../../context/products";
import { useLocalizedSentenceDict } from "../../hooks/useSentenceDict";
import useResponsiveWithHydrationFix from "../../hooks/useResponsiveWithHydrationFix";
import ProductCard from "./productsCarousel/ProductCard";

import IconArrowCircleMd from "../icons/svgs/arrow-circle-md.svg";

import "swiper/swiper.min.css";
import "swiper/swiper-bundle.min.css";
import * as Styles from "./productsCarousel/styles.module.scss";

SwiperCore.use([Navigation, Pagination, A11y]);

function ProductsCarousel({ content, componentType }) {
  const { data: products } = useProductData2(content.productHandles, "long");
  const dict = useLocalizedSentenceDict();

  let nbSlides = 4;
  if (products.length % 3 === 0) {
    nbSlides = 3;
  } else if (products.length < 3) {
    nbSlides = 2;
  }
  const DesktopLayout = (
    <Swiper
      navigation={{
        nextEl: `.next-button-${content.contentful_id}`,
        prevEl: `.prev-button-${content.contentful_id}`,
      }}
      slidesPerView={nbSlides}
      slidesPerGroup={nbSlides}
      spaceBetween={28}
    >
      {products.map((product) => (
        <SwiperSlide key={product.handle}>
          <ProductCard product={product} />
        </SwiperSlide>
      ))}
    </Swiper>
  );

  const MobileLayout = (
    <div className={Styles.container__mobile}>
      {products.map((product) => (
        <ProductCard key={product.handle} product={product} />
      ))}
    </div>
  );

  const productList = useResponsiveWithHydrationFix(MobileLayout, DesktopLayout);

  if (products.length === 0) {
    return null;
  }

  return (
    <div
      className={`${Styles.container} id-${content.contentful_id} ${
        Styles[componentType?.toLowerCase()]
      }`}
    >
      <div className={Styles.header}>
        <h2 className={`${Styles.title} h2 h2--bold h2--uc`}>
          {content?.title !== "null" && content.title}
        </h2>
        <div className={Styles.buttons}>
          <button
            className={`prev-button prev-button-${content.contentful_id} ${Styles.prevButton}`}
            type="button"
            aria-label={dict.get("previous")}
          >
            <IconArrowCircleMd width="32" stroke="#2D2927" />
          </button>
          <button
            className={`next-button next-button-${content.contentful_id} ${Styles.nextButton}`}
            type="button"
            aria-label={dict.get("next")}
          >
            <IconArrowCircleMd width="32" stroke="#2D2927" />
          </button>
        </div>
      </div>

      {productList}
    </div>
  );
}

ProductsCarousel.propTypes = {
  content: PropTypes.shape({
    contentful_id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    productHandles: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  componentType: PropTypes.string,
};

export default withALErrorBoundary({
  name: "ProductsCarousel",
  priority: "P2",
})(ProductsCarousel);
